import Form     from 'scripts/poppet/form';
import template from 'templates/subscriptionPackageOptionForm.jst.html';

/**
 * defa.views.SubscriptionPackageOptionForm
 * A view for selecting if you want a subscription package.
 * @version 1.2.0
 */
const SubscriptionPackageOptionForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		const value = this.$el.find( ':checked' ).val();
		this.trigger( value ); // change, clear, or skip.
	},
	
} );


export default SubscriptionPackageOptionForm;